<script>
    import { onMount } from "svelte";
    import { get } from "svelte/store";
    import Button from "./Button.svelte";
    import IconLink from "./IconLink.svelte";
    import Lobby from "./Lobby.svelte";
    import NoServersMessage from "./NoServersMessage.svelte";
    import PlayerConfigHotseat from "./PlayerConfigHotseat.svelte";
    import {
        isInRoom,
        isConnecting,
        connected,
        syncConnectedWithPieState,
        disconnect,
        isDisconnecting,
    } from "./stores";
    export let setRoute;
    let isJoining = false;
    let urlSearchParams = new URLSearchParams(location.search);
    let wsUrl = urlSearchParams.get("pieUrl");
    let gameName = urlSearchParams.get("game");
    let gamePassword;
    let joinRoomErrorText = "";
    let connectionError = "";
    let numOfHotseatPlayers = 2;
    let previousCustomUrls =
        globalThis.storageGet("previousCustomUrls") || "[]";
    try {
        previousCustomUrls = JSON.parse(previousCustomUrls);
    } catch (e) {
        console.error("Could not parse previousCustomUrls");
    }

    let localServerStatus = {
        starting: false,
        running: false,
    };

    function connect() {
        if (wsUrl) {
            console.log("Menu: Connect to server", wsUrl);
            $isConnecting = true;
            const url = new URL(location.href);
            url.searchParams.set("pieUrl", wsUrl);
            window.history.pushState(null, null, url);
            // Clear error now that we are rejoining
            connectionError = "";
            debugger;
            return window
                .connect_to_wsPie_server(wsUrl)
                .catch((e) => {
                    console.error("Connection error:", e);
                    connectionError = e;
                })
                .then(() => {
                    syncConnectedWithPieState();
                    if (get(connected)) {
                        try {
                            if (subRoute == CUSTOM_SERVER) {
                                previousCustomUrls.unshift(wsUrl);
                                // deduplicate
                                previousCustomUrls = previousCustomUrls.filter(
                                    (x, i) =>
                                        previousCustomUrls.indexOf(x) === i,
                                );
                                globalThis.storageSet(
                                    "previousCustomUrls",
                                    JSON.stringify(previousCustomUrls),
                                );
                            }
                        } catch (e) {
                            console.error(
                                "Could not save previousCustomUrls",
                                e,
                            );
                        }
                        connectionError = "";
                    }
                });
        }
        return Promise.reject("No wsUrl defined to connect to");
    }
    function leaveRoom() {
        window.pieLeaveRoom();
        $isInRoom = false;
    }
    function join(isHosting) {
        if (gameName) {
            if (window.isConnected()) {
                // Note: Must not join a room until pixi is setup
                console.log("Menu: Connect to game name", gameName);
                // Now that we are both connected to the pieServer and assets are loaded,
                // we can host or join a game
                isJoining = true;
                // Reset error
                joinRoomErrorText = "";
                // TODO: differentiate making room and joining room
                return window
                    .joinRoom(
                        { name: gameName, password: gamePassword },
                        isHosting,
                    )
                    .then(() => {
                        const url = new URL(location.href);
                        url.searchParams.set("game", gameName);
                        window.history.pushState(null, null, url);
                        $isInRoom = true;
                    })
                    .catch((e) => {
                        console.error("Could not join room", e);
                        joinRoomErrorText = e;
                    })
                    .then(() => {
                        isJoining = false;
                    });
            } else {
                console.error(
                    "Cannot join room until pieClient is connected to a pieServer",
                );
            }
        } else {
            console.log("Cannot join game until a gameName is provided");
        }
        return Promise.resolve();
    }
    let serverListPromise;
    onMount(() => {
        syncConnectedWithPieState();
        // Get server list from server hub:
        serverListPromise = fetch(
            "",
        )
            .then((response) => {
                return response.json();
            })
            .then((x) => {
                console.log("Serverlist:", x);
                return x;
            })
            .catch(console.error);
        // Subscribe to Local Server messages:
        console.log("Subscribe to local server messages");
        globalThis.localServer?.onStatus((_localServerStatus) => {
            console.log("Local server status", localServerStatus);
            localServerStatus = _localServerStatus;
            if (localServerStatus.running) {
                wsUrl = "ws://localhost:8080";
                connect();
            }
        });
        // For quickly joining a multiplayer game for testing
        const quickJoin = globalThis.storageGet("devQuickJoin");
        // If not already connected, quickjoin
        if (quickJoin && !get(connected)) {
            console.log("dev: Auto joining", quickJoin);

            window
                .connect_to_wsPie_server("ws://localhost:8080")
                .catch((e) => {
                    console.error("Connection error:", e);
                    connectionError = e;
                })
                .then(syncConnectedWithPieState)
                .then(() => {
                    gameName = quickJoin;
                    return join(true);
                })
                .then(() => {
                    globalThis.configPlayer({ lobbyReady: true });
                });
        }
    });
    const SERVER_BROWSER = "SERVER_BROWSER";
    const CUSTOM_SERVER = "CUSTOM_SERVER";
    const LOCAL = "LOCAL";
    const HOTSEAT = "HOTSEAT";
    let subRoute = SERVER_BROWSER;
    function setOptionsRoute(_subRoute) {
        // Disconnect from current server when changing route
        if (_subRoute !== subRoute) {
            wsUrl = "";
            window.intentionalDisconnect = true;
            disconnect();
        }
        subRoute = _subRoute;
    }
</script>

<div class="flex height100">
    <aside class="height100">
        <div
            class="flex flex-direction-column justify-content-space-between height100"
        >
            <div class="flex flex-direction-column gap-15 pad-20">
                <div class="flex align-items-center gap-20">
                    <Button
                        on:click={() => {
                            window.goBack();
                        }}
                        type="button"
                        text="🠔 Back"
                        class="sm"
                    />
                    <h1 class="aside-title">
                        {globalThis.i18n("Multiplayer")}
                    </h1>
                </div>
                <div class="flex flex-direction-column gap-15">
                    {#if location.href.includes("localhost")}
                        <Button
                            on:click={() => {
                                // Dev helper button, quickly connect to local dev server
                                setOptionsRoute(CUSTOM_SERVER);
                                wsUrl = "ws://localhost:8080";
                                connect();
                            }}
                            text="localhost:8080"
                            type="button"
                            style="text-align:left"
                            doLocalizeText={false}
                        />
                    {/if}
                    <Button
                        on:click={() => setOptionsRoute(SERVER_BROWSER)}
                        isActive={subRoute == SERVER_BROWSER}
                        type="button"
                        text={`${globalThis.i18n("Community Servers")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(CUSTOM_SERVER)}
                        isActive={subRoute == CUSTOM_SERVER}
                        type="button"
                        text={`${globalThis.i18n("Custom Server")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(LOCAL)}
                        isActive={subRoute == LOCAL}
                        type="button"
                        text={`${globalThis.i18n("Local (LAN)")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                    <Button
                        on:click={() => setOptionsRoute(HOTSEAT)}
                        isActive={subRoute == HOTSEAT}
                        type="button"
                        text={`${globalThis.i18n("Hotseat Multiplayer")}`}
                        style="text-align:left"
                        doLocalizeText={false}
                    />
                </div>
            </div>
            <IconLink
                src="ui/externalLink.svg"
                href="https://youtu.be/8CTbL38eCvk"
                text="How to Host your own Server"
            />
        </div>
    </aside>

    <main>
        {#if $isDisconnecting}
            <div class="connecting-spinner">
                <div class="lds-ellipsis">
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        {:else}
            <div class="pad-20" style="min-width:400px;">
                {#if subRoute == HOTSEAT}
                    <div class="margin-bottom-15">
                        {globalThis.i18n("hotseat_description")}
                    </div>
                    <div class="flex gap-15 margin-bottom-15">
                        <Button
                            text={"Add Player"}
                            on:click={() => {
                                numOfHotseatPlayers += 1;
                            }}
                            style="width:auto;"
                        />
                        {#if numOfHotseatPlayers > 2}
                            <Button
                                text={"Remove Player"}
                                on:click={() => {
                                    numOfHotseatPlayers -= 1;
                                }}
                                style="width:auto;"
                            />
                        {/if}
                    </div>
                    {#each { length: numOfHotseatPlayers } as _, i}
                        <PlayerConfigHotseat
                            index={i}
                            name={`Player ${i + 1}`}
                        />
                    {/each}
                    <Button
                        text={"Start Game"}
                        style="width:auto;"
                        iconPath="forward.png"
                        on:click={() => {
                            // Start music on button click to get past Firefox permissions
                            window.playMusic();
                            // Connect to solo
                            window
                                .startSingleplayer(numOfHotseatPlayers)
                                .then(() => {
                                    syncConnectedWithPieState();
                                });
                        }}
                    />
                {:else}
                    {#if subRoute == SERVER_BROWSER}
                        <div class="margin-bottom-15">
                            {#await serverListPromise}
                                <p>...fetching servers</p>
                            {:then serverList}
                                <h2>{globalThis.i18n("Community Servers")}</h2>
                                {#if serverList}
                                    <div
                                        class={serverList?.message
                                            ? "margin-bottom-15 max-width-800"
                                            : ""}
                                    >
                                        {serverList?.message || ""}
                                    </div>
                                    {#if serverList && serverList.servers && serverList.servers.length !== 0}
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th
                                                        >{globalThis.i18n(
                                                            "Name",
                                                        )}</th
                                                    >
                                                    <th
                                                        >{globalThis.i18n(
                                                            "Region",
                                                        )}</th
                                                    >
                                                    <th
                                                        >{globalThis.i18n(
                                                            "Version",
                                                        )}</th
                                                    >
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {#if serverList?.servers}
                                                    {#each serverList.servers as server (server.url)}
                                                        {#if server}
                                                            <tr
                                                                class={wsUrl ==
                                                                    server.url &&
                                                                $connected
                                                                    ? "active"
                                                                    : ""}
                                                            >
                                                                <td
                                                                    >{server.name}</td
                                                                >
                                                                <td
                                                                    >{server.region}</td
                                                                >
                                                                <td
                                                                    >{server.appVersion
                                                                        ? `v${server.appVersion}`
                                                                        : "Unknown"}</td
                                                                >
                                                                <td>
                                                                    {#if wsUrl == server.url && $isConnecting}
                                                                        <div
                                                                            class="connecting-spinner"
                                                                        >
                                                                            <div
                                                                                class="lds-ellipsis"
                                                                            >
                                                                                <div
                                                                                />
                                                                                <div
                                                                                />
                                                                                <div
                                                                                />
                                                                                <div
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    {:else if $connected}
                                                                        {#if wsUrl == server.url}
                                                                            <div
                                                                                class="flex gap-15"
                                                                            >
                                                                                <Button
                                                                                    text={"Connect"}
                                                                                    disabled={true}
                                                                                    doLocalizeText={false}
                                                                                />
                                                                                <Button
                                                                                    on:click={disconnect}
                                                                                    text="Disconnect"
                                                                                />
                                                                            </div>
                                                                        {/if}
                                                                    {:else}
                                                                        <Button
                                                                            on:click={() => {
                                                                                wsUrl =
                                                                                    server.url;
                                                                                connect();
                                                                            }}
                                                                            text={"Connect"}
                                                                            class="connect-btn"
                                                                            doLocalizeText={false}
                                                                        />
                                                                    {/if}
                                                                </td>
                                                            </tr>
                                                        {/if}
                                                    {/each}
                                                {/if}
                                            </tbody>
                                        </table>
                                    {:else}
                                        <NoServersMessage />
                                    {/if}
                                {:else}
                                    <NoServersMessage />
                                {/if}
                            {:catch error}
                                <p style="color: red">{error.message}</p>
                            {/await}
                        </div>
                    {/if}
                    {#if subRoute == LOCAL}
                        <div class="flex gap-15 margin-bottom-15">
                            <Button
                                on:click={() => {
                                    globalThis.localServer.start();
                                }}
                                text="Host Local Server"
                            />
                            <Button
                                on:click={() => {
                                    globalThis.localServer.start();
                                }}
                                disabled={!localServerStatus.running}
                                text="Stop Local Server"
                            />
                        </div>
                        {#if localServerStatus.starting && !localServerStatus.running}
                            <div class="connecting-spinner">
                                <div class="connecting-text">
                                    {globalThis.i18n(
                                        "Starting local server",
                                    )}...
                                </div>
                                <div class="lds-ellipsis">
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                </div>
                            </div>
                        {/if}
                    {/if}
                    {#if subRoute !== SERVER_BROWSER}
                        <label for="server-url"
                            >{globalThis.i18n("Server Url")}</label
                        >
                        <div>
                            <input
                                id="server-url"
                                bind:value={wsUrl}
                                on:keypress={(e) => {
                                    e.key == "Enter" && connect();
                                }}
                            />
                            <div class="flex gap-15">
                                <Button
                                    on:click={connect}
                                    disabled={$connected}
                                    text="Connect"
                                />
                                <Button
                                    on:click={disconnect}
                                    disabled={!$connected}
                                    text="Disconnect"
                                />
                            </div>
                        </div>
                        {#if subRoute == CUSTOM_SERVER && !$connected}
                            <div
                                class="flex flex-direction-column gap-15"
                                style="margin-top:1em;"
                            >
                                {#each previousCustomUrls as previousCustomUrl}
                                    <Button
                                        on:click={() => {
                                            // Dev helper button, quickly connect to local dev server
                                            setOptionsRoute(CUSTOM_SERVER);
                                            wsUrl = previousCustomUrl;
                                            connect();
                                        }}
                                        text={`🕒 ${previousCustomUrl}`}
                                        type="button"
                                        style="text-align:left; text-transform:none;"
                                        doLocalizeText={false}
                                    />
                                {/each}
                            </div>
                        {/if}
                    {/if}
                    {#if $isConnecting}
                        <div class="connecting-spinner">
                            <div class="connecting-text">
                                {globalThis.i18n("Connecting")}...
                            </div>
                            <div class="lds-ellipsis">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    {/if}
                    <div class="error-inline">{connectionError}</div>
                    {#if $connected}
                        <div class="flex gap-15">
                            <div style="width:65%;">
                                <label for="game-name"
                                    >{globalThis.i18n("Game name")}</label
                                >
                                <input
                                    id="game-name"
                                    bind:value={gameName}
                                    on:keypress={(e) => {
                                        e.key == "Enter" && join(true);
                                    }}
                                    disabled={$isInRoom}
                                />
                            </div>
                            <div style="width:35%;">
                                <label for="game-password"
                                    >{globalThis.i18n(
                                        "Password (Optional)",
                                    )}</label
                                >
                                <input
                                    id="game-password"
                                    bind:value={gamePassword}
                                    on:keypress={(e) => {
                                        e.key == "Enter" && join(true);
                                    }}
                                    disabled={$isInRoom}
                                />
                            </div>
                        </div>
                        {#if isJoining}
                            Joining...
                            <div class="lds-ellipsis">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        {:else if $isInRoom}
                            <Button
                                on:click={leaveRoom}
                                text="Leave Room"
                                style="max-width:50%;"
                            />
                        {:else}
                            <div class="flex gap-15">
                                <Button
                                    on:click={() => {
                                        // true denotes that this is HOSTING not just joining
                                        join(true).then(() => {
                                            console.log(
                                                "Host: setting mods on server",
                                            );
                                            globalThis.saveActiveMods(
                                                globalThis.activeMods,
                                            );
                                        });
                                    }}
                                    text="Host"
                                />
                                <Button on:click={join} text="Join" />
                            </div>
                            <div class="error-inline">{joinRoomErrorText}</div>
                        {/if}
                    {/if}
                    {#if $isInRoom}
                        <Lobby {setRoute} />
                    {/if}
                {/if}
            </div>
        {/if}
    </main>
</div>

<style>
    table {
        border-collapse: collapse;
        border: 1px solid white;
    }
    thead tr {
        background-color: #483f8e;
        color: #ffffff;
        text-align: left;
    }

    table th,
    table td {
        padding: 12px 15px;
    }
    table tbody tr:nth-of-type(even) {
        background-color: #242424;
    }
    /* :global(table tr:hover .connect-btn) {
        visibility: visible;
    }
    :global(table tr .connect-btn) {
        visibility: hidden;
    } */

    table tbody td:not:first-child {
        text-align: center;
    }

    table tbody tr.active {
        font-weight: bold;
        color: #7a6fcc;
    }
    .connecting-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .connecting-text {
        transform: translate(0, 20px);
    }
    input {
        font-size: inherit;
        -webkit-padding: 0.4em 0;
        padding: 0.4em;
        margin: 0 0 0.5em 0;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 2px;
        width: 100%;
    }
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(24px, 0);
        }
    }
</style>
